import React, { Component } from 'react';
import withRouter from "../../../Utils/withRouter";
import Swal from "sweetalert2";
import axios from "axios";
import { ConfigContext } from "../../../Context/ConfigContext";
import { NoRecords } from '../../../Components/Shimmer';
import { currentDateAndTime, parseQueryString, validateDateFormat } from '../../../Constants/constants';
import Select from 'react-select';
import { formatDate } from '../../../Components/InputElements';

class EducationDetails extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);

    // Initial state to store form data and validation errors
    this.state = {
      employee_degree: '',
      institute_university: '',
      year_of_passout: '',
      percentage_grade: '',
      employee_qualification_document: '',
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      loadingSubmit: false,
      keyword: "",
      from_date: "",
      to_date: "",
      errors: {}, 
      education_status:"1",
      academic_score_value:"",
      academic_score_type:"1",
      employee_qualification_id:"",
    };
    this.closeRef = React.createRef();
  }
  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const encryptedData = queryParams.get("data");
    if (encryptedData) {
    this.setState({
        loadingList:true,
            encryptedData:encryptedData,
            guest_employee_mobile_number: "",
            company_id: "",
       }, (prevState) => {
        this.getDecryptedData();
      });
    } else if (!encryptedData) {
      this.setState({
        encryptedData:'',
        guest_employee_mobile_number: "",
        company_id: "",
      });
    }
  }
  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleRadioChange = (name, value) => {
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  // Handler function for Select component change
  handleSelectChange = (name, selectedOption) => {
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: { ...prevState.errors, [name]: '', },
    }));
  };

  // Handler function for form submission
  handleSubmit = (e) => {
    e.preventDefault();
    const errors = this.validateForm();
    console.log("CreateUpdateEmployeeEducationalDetails ERROR",errors)
    if (Object.keys(errors).length > 0) {
      // If there are validation errors, update the state with the errors
      this.setState({ errors });
      return;
    }
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
  this.setState({loadingSubmit:true});
    const formData={
      employee_educational_detail:[{
          "employee_qualification_id": this.state.employee_qualification_id || null,
          'employee_degree': this.state.employee_degree,
          'institute_university': this.state.institute_university,
          'education_status': this.state.education_status,
          'year_of_passout': this.state.year_of_passout,
          'academic_score_type': this.state.academic_score_type,
          'academic_score_value': this.state.academic_score_value,
      },],
    }
    console.log(formData);
    axios.post(`${apiURL}Home/CreateUpdateEmployeeEducationalDetails`, formData, {
      params:{
        date: currentDateAndTime(),
        company_id: this.state.company_id,
        guest_employee_mobile_number: this.state.guest_employee_mobile_number,
      },
      headers }).then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({
          employee_qualification_id:"",
          employee_degree: '',
          institute_university: '',
          year_of_passout: '',
          percentage_grade: '',
          employee_qualification_document: '',
        });
        this.closeRef.current.click();

        this.setState({ loadingList: true, loadingSubmit:false }, (prevState) => {
          this.GetList();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
        this.setState({ loadingList: false, loadingSubmit:false })
      }
    }).catch((error)=>{
      Swal.fire({
        title: `<strong>Failed</strong>`,
        text: 'Opps...! Something went wrong.',
        icon: 'error',
        showConfirmButton: true,
        allowOutsideClick:false
      })
      
    }).finally(this.setState({ loadingList: false, loadingSubmit:false }))
  };
  handleSelectFile = (e) => {
    const file = e.target.files[0];
    this.setState({
      employee_qualification_document: file,
      selectedFileName: file ? file.name : '',
    });
  };
  removeSelectedFile = () => {
    this.setState({
      employee_qualification_document: null,
      selectedFileName: '',
    });
  };


  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Home/EmployeeCollectedData`, {
        params: {
          company_id: this.state.company_id,
            guest_employee_mobile_number:this.state.guest_employee_mobile_number,
            date: currentDateAndTime(),
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          employee_id: this.props.params.employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data?.employee_qualification_detail,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  getDecryptedData = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const fromData={
        encryptedData:this.state.encryptedData
    }
    axios
        .post(`${apiURL}User/DecryptData`,fromData, {headers})
        .then((response) => {
            var data = response.data;
            console.log('DecryptData',data);
            if (response.data.success === true) {
                let temp= parseQueryString(data?.decryptedData);
                console.log("tenp",temp);
                this.setState({
                  company_id:temp?.c_id,
                  guest_employee_mobile_number:temp?.mo_n,
                },()=>{
                  this.GetList();
                });
            } else {
              this.setState({
        
                loadingList: false,
              });
            }
        }).catch((error)=>{
          this.setState({
            loadingList: false,
          });
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: "Opps...! Something went wrong !!",
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false
            })
        });
};

handleEdit= (row)=>{
  this.setState({
    employee_qualification_id: row?.employee_qualification_id,
    employee_degree: row?.employee_degree,
    institute_university: row?.institute_university,
    education_status: row?.education_status,
    year_of_passout: row?.year_of_passout,
    academic_score_type: this.state.academic_score_type,
    academic_score_value: this.state.academic_score_value,
    employee_qualification_document: row?.employee_qualification_document,
  })
}

  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to Delete this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_qualification_id: id,
        };
        axios
          .post(`${apiURL}Home/DeleteEducationDetails`, formData, {
            params:{
              company_id: this.state.company_id,
          guest_employee_mobile_number:this.state.guest_employee_mobile_number,
          date: currentDateAndTime(),
            },
             headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
              showConfirmButton: true,
          allowOutsideClick:false
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
              showConfirmButton: true,
              allowOutsideClick:false
            });
          });
      }
    });
  };

  // Custom validation function with regex
  validateForm = () => {
    const errors = {};
    const numberRegex = /^[0-9]+$/;

    if (!this.state.institute_university) errors.institute_university = 'Institute or University is required';
    if (!this.state.employee_degree) errors.employee_degree = 'Degree is required';
    if (!this.state.education_status) errors.education_status = 'Education Status is required';
    if (this.state.education_status==="1" && !this.state.year_of_passout) errors.year_of_passout = 'Passout year is required';
    if (this.state.education_status==="2" && !this.state.year_of_passout) errors.year_of_passout = 'Year of passing is required';
    if (this.state.year_of_passout){
      const passoutYear= this.state.year_of_passout;
      const year = validateDateFormat(passoutYear);
      if (!year?.isValid) {
        errors.year_of_passout = year?.message;
      }
      else if (this.state.education_status==="1" && passoutYear > currentDateAndTime()) {
        errors.year_of_passout = "Passout Date cannot be in the future.";
      }
      else if (this.state.education_status==="2" && passoutYear < currentDateAndTime()) {
        errors.year_of_passout = "Passing Date cannot be in the past.";
      }
    };
    if (!this.state.academic_score_value) errors.academic_score_value = `Academic score can not be empty.`;

    if (this.state.academic_score_value && this.state.academic_score_type === '1'){
      if(!numberRegex.test(this.state.academic_score_value)){
        errors.academic_score_value = 'Invalid academic score';
      }
      else if(parseInt(this.state.academic_score_value)>100){
        errors.academic_score_value = 'Percentage can not be more than 100.';
      }
      else if(parseInt(this.state.academic_score_value)<1){
        errors.academic_score_value = 'Percentage can not be less than 1.';
      }
    } 
    if (this.state.academic_score_value && this.state.academic_score_type === '2'){
      if(numberRegex.test(this.state.academic_score_value)){
        errors.academic_score_value = 'Grade can not be a number.';
      }
    } 
    if (this.state.academic_score_value && this.state.academic_score_type === '3'){
      if(!numberRegex.test(this.state.academic_score_value)){
        errors.academic_score_value = 'Invalid academic score';
      }
      else if(parseInt(this.state.academic_score_value)>10){
        errors.academic_score_value = 'CGPA can not be more than 10.';
      }
      else if(parseInt(this.state.academic_score_value)<1){
        errors.academic_score_value = 'CGPA can not be less than 1.';
      }
    } 

    return errors;
  };


  render() {
    const { errors, loadingList } = this.state;
    const scoreTypeOptions=[
      {value: "1", label: "Percentage"},
      {value: "2", label: "Grade"},
      {value: "3", label: "CGPA"},
    ]
    return loadingList? (
      <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
          <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
              </div>
          </div>
      </div>
    ) :(
      <>
        <div className='d-flex justify-content-between align-itmes-center'>
          <h5> Educational Details 
          <span
            style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
            *
          </span>
          </h5>
          <div>
            {/* Grids in modals */}
            <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#EducationalDetails">
              <i className="ri-menu-add-fill" style={{ fontSize: "16px" }} />
              Add
            </button>
            <div className="modal fade" id="EducationalDetails" tabIndex={-1} aria-labelledby="exampleModalgridLabel" aria-modal="true">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalgridLabel">Add Educational Details</h5>
                    <button type="button" className="btn-close" ref={this.closeRef} data-bs-dismiss="modal" aria-label="Close" />
                  </div>
                  <div className="modal-body">
                    <div className="container mt-2">
                      <form onSubmit={this.handleSubmit}>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="employee_degree" className="form-label">Qualification:
                            <span
                              style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                              *
                            </span>
                            </label>
                            <input
                              type="text"
                              id="employee_degree"
                              name="employee_degree"
                              value={this.state.employee_degree}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.employee_degree ? 'is-invalid' : ''}`}
                              placeholder="Enter Qualification:"
                            />
                            {errors.employee_degree && <div className="invalid-feedback">{errors.employee_degree}</div>}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="institute_university" className="form-label">Institute/University:<span
                              style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                              *
                            </span></label>
                            <input
                              type="text"
                              id="institute_university"
                              name="institute_university"
                              value={this.state.institute_university}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.institute_university ? 'is-invalid' : ''}`}
                              placeholder="Enter Institute/University"
                            />
                            {errors.institute_university && <div className="invalid-feedback">{errors.institute_university}</div>}
                          </div>
                          <div className="col-md-6 mb-3">
                              <div>
                                <label htmlFor="is_Dependend" className="form-label">Education Status:
                                <span
                                style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                *
                                </span>
                              </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  type="radio"
                                  id="educationStatusYes"
                                  name="education_status"
                                  value="1"
                                  checked={this.state.education_status === '1'}
                                  onChange={() => this.handleRadioChange('education_status', '1')}
                                  className={`form-check-input ${errors.education_status ? 'is-invalid' : ''}`}
                                />
                                <label htmlFor="educationStatusYes" className="form-check-label">Completed</label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  type="radio"
                                  id="educationStatusNo"
                                  name="education_status"
                                  value="2"
                                  checked={this.state.education_status === '2'}
                                  onChange={() => {this.handleRadioChange('education_status', '2'); this.setState({ year_of_passout:"" })}}
                                  className={`form-check-input ${errors.education_status ? 'is-invalid' : ''}`}
                                />
                                <label htmlFor="educationStatusNo" className="form-check-label">Appearing</label>
                              </div>
                              {errors.education_status && <div className="text-danger">{errors.education_status}</div>}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="year_of_passout" className="form-label">Year Of {this.state.education_status==="1"?"Passout":"Passing"}:
                              <span
                                style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                *
                              </span>
                            </label>
                            <input
                              type="date"
                              id="year_of_passout"
                              name="year_of_passout"
                              // disabled={this.state.education_status==="2"}
                              value={this.state.year_of_passout}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.year_of_passout ? 'is-invalid' : ''}`}
                              placeholder="Enter Year Of Passing"
                            />
                            {errors.year_of_passout && <div className="invalid-feedback">{errors.year_of_passout}</div>}
                          </div>
                          <div className="col-md-6 mb-3">
                              <label htmlFor="academic_score_type" className="form-label">Academic Scores:</label>
                              <Select
                                id="academic_score_type"
                                name="academic_score_type"
                                className={`${errors.emergency_Contact_Person ? 'is-invalid' : ''}`}
                                value={this.state.academic_score_type ? scoreTypeOptions.find(option => option.value === this.state.academic_score_type):null}
                                onChange={(selectedOption) => this.handleSelectChange('academic_score_type', selectedOption)}
                                options={scoreTypeOptions}
                                placeholder="Enter Your Academic Scores"
                              />
                          </div>
                          <div className="col-md-6">
                              <label htmlFor="academicscore_value" className="form-label">
                                Enter Your  {this.state.academic_score_type === '1' 
                                  ? 'Percentage' 
                                  : this.state.academic_score_type === '2' 
                                  ? 'Grade' 
                                  : this.state.academic_score_type === '3' 
                                  ? 'CGPA' 
                                  : ''}
                                  <span
                                    style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                    *
                                  </span>
                              </label>

                                <input
                                  type="text"
                                  id="academicscore_value"
                                  disabled={!this.state.academic_score_type}
                                  name="academic_score_value"
                                  value={this.state.academic_score_value}
                                  onChange={this.handleInputChange}
                                  className={`form-control ${errors.academic_score_value ? 'is-invalid' : ''}`}
                                  placeholder={`Enter Your Academic Score ${this.state.academic_score_value? this.state.academic_score_value:""}`}  // This placeholder will dynamically change based on selected score type
                                />
                                {errors.academic_score_value && <div className="invalid-feedback">{errors.academic_score_value}</div>}
                            </div>
                        </div>
                         
                          {/* <div className="col-md-6 mb-3">
                            <label htmlFor="percentage_grade" className="form-label">Percentage Grade:<span
                              style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                              *
                            </span></label>
                            <input
                              type="number"
                              id="percentage_grade"
                              name="percentage_grade"
                              value={this.state.percentage_grade}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.percentage_grade ? 'is-invalid' : ''}`}
                              placeholder="Enter Your Grade"
                            />
                            {errors.percentage_grade && <div className="invalid-feedback">{errors.percentage_grade}</div>}
                          </div> */}
                          {/* <div className="col-md-6 mb-3">
                            <label htmlFor="employee_qualification_document" className="form-label">
                              Employee Qualification Document<span className='muted'>...(optional)</span>
                            </label>
                            <div>
                              <label htmlFor="employee_qualification_document" className="btn btn-primary mt-3">
                                Choose File
                              </label>
                            </div>
                            <input
                              type="file"
                              id="employee_qualification_document"
                              name="employee_qualification_document"
                              onChange={this.handleSelectFile}
                              className="form-control d-none"
                              placeholder="Enter Your Qualification Document"
                              accept="image/*,.pdf"
                            />
                            {this.state.selectedFileName && (
                              <div className="mt-2 d-flex align-items-center">
                                <span>Selected file: {this.state.selectedFileName}</span>
                                <button
                                  type="button"
                                  className="btn-close ms-2"
                                  aria-label="Close"
                                  onClick={this.removeSelectedFile}>
                                </button>
                              </div>
                            )}
                          </div> */}
                          <div className="d-flex justify-content-end">
                            {!this.state.loadingSubmit?
                            <button type="submit" className={`btn btn-${this.state.employee_qualification_id? "primary":"success" } btn-label waves-effect right waves-light`}>
                              <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> {this.state.employee_qualification_id? "Update" :"Save"}</button>:
                            <button className={`btn btn-${this.state.employee_qualification_id? "primary":"success"} btn-load`}>
                            <span className="d-flex align-items-center">
                                <span className="spinner-border flex-shrink-0" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </span>
                                <span className="flex-grow-1 ms-2">
                                    {this.state.employee_qualification_id? "Updating..." :"Saving..."}
                                </span>
                            </span>
                          </button>}
                          </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className={`table table-bordered table-stripped`}>
            <thead className="table-light">
              <tr>
                <th>Enter Qualification</th>
                <th>Institute</th>
                <th>Year Of Passing</th>
                <th>Academic Score</th>
                {/* <th>Qualification Document</th> */}

                <th className="text-center">Action</th>
              </tr>
            </thead>
            {
              this.state.rows?.length === 0?
              <tbody>
                    <tr>
                        <td colSpan={9}>
                            <NoRecords/>
                        </td>
                    </tr>
                </tbody>:
                <tbody>
              {this.state.rows.map((row) => {
                return (
                  <tr key={row.employee_qualification_id}>
                    <td>{row.employee_degree || "--"}</td>
                    <td>{row.institute_university || "--"}</td>
                    <td>{row?.year_of_passout? formatDate(row?.year_of_passout):"--"}</td>
                    <td className=' text-center'>
                      {row?.academic_score_value}{' '}
                      {row?.academic_score_type === '1'
                      ? '%'
                      : row?.academic_score_type === '2'
                      ? 'Grade'
                      : row?.academic_score_type === '3'
                      ? 'CGPA'
                      : ''}
                    </td>
                    {/* <td>
                      <div className='d-flex justify-content-center align-items-center'>
                        <a href={`${row.employee_qualification_document_url}`}
                          className={`${!row.employee_qualification_document_url ? ('d-none') : ''} link-info link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover`}
                          target="_blank" rel="noopener noreferrer">
                          View Uploaded Document
                        </a>
                      </div>
                    </td> */}
                    <td className="d-flex justify-content-around">
                    <button
                           onClick={() =>
                            this.handleEdit(row)
                        }
                              data-bs-toggle="modal" data-bs-target="#EducationalDetails"
                                className="btn-icon btn btn-sm btn-outline-primary">
                                <i className="ri-edit-box-line"></i>
                          </button>
                      <button
                        onClick={() =>
                          this.handleDelete(row.employee_qualification_id)
                        }
                        className="btn-icon btn btn-sm btn-outline-danger"
                      >

                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            }
            
            {/* <tfoot className="table-light">
              <tr>
                <th colSpan={6}>
                  <div className="d-flex justify-content-between">
                    <button
                      disabled={
                        this.state.prev === false &&
                          this.state.loadingList === false
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => this.handlePrev()}
                      className={`btn btn-warning btn-label waves-effect waves-light`}
                    >
                      <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                      Previous
                    </button>
                    <div
                      className="col-md-4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {
                        <small>
                          Total Records: {this.state.total_records} |
                          Total Pages: {this.state.total_pages} |
                          Current Page: {this.state.page}
                        </small>
                      }
                    </div>
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        onChange={(e) => this.handleChange(e)}
                      >
                        {Array.from(
                          { length: this.state.total_pages },
                          (_, i) => (
                            <option
                              selected={this.state.page === i + 1}
                              key={i}
                              value={i + 1}
                            >
                              Page {i + 1}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    <button
                      disabled={
                        this.state.next === false &&
                          this.state.loadingList === false
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => this.handleNext()}
                      className={`btn btn-primary btn-label waves-effect right waves-light`}
                    >
                      <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                      Next
                    </button>
                  </div>
                </th>
              </tr>
            </tfoot> */}
          </table>
        </div>
      </>
    );
  }
}

export default withRouter(EducationDetails);
